import { z } from 'zod';
import { horairesSchema } from './agenda.js';
/**
 * Ce qu'une BOUTIQUE règle elle-même, depuis son module Paramètres.
 *
 * ⭐ Ces réglages vivent dans le SCHÉMA de la boutique, pas dans la table
 * commune : les jours d'ouverture d'une enseigne ne regardent qu'elle. Ils
 * étaient rangés à côté de l'activation des modules — un réglage d'exploitation
 * qui, lui, doit rester dehors — parce que les deux étaient arrivés ensemble,
 * pas parce qu'ils allaient ensemble.
 *
 * ⚠️ Un schéma à part, et non celui de la console amputé : la différence entre
 * les deux EST la règle de sécurité. Ni `modules`, ni `slug`, ni le pays ou la
 * monnaie n'y figurent — le premier enfermerait le gérant dehors s'il coupait
 * « Paramètres » depuis Paramètres, le deuxième casserait les favoris et les
 * invitations en attente, les derniers sont figés dans chaque document émis.
 */
export const reglagesBoutiqueSchema = z
    .object({
    horaires: horairesSchema.optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Rien à modifier' });
//# sourceMappingURL=boutique.js.map